import { z } from 'zod';

export const TradeStudyInputs = z.object({
  id: z.coerce.number().int(),
  quote_id: z.coerce.number().int(),
  total_assemblies_required: z.coerce.number().int(),
  parts_per_assembly: z.coerce.number().int(),
  program_duration_years: z.coerce.number().int(),
  m_days_per_month: z.coerce.number().int(),
  layout_shifts: z.coerce.number().int(),
  layout_hours_per_shift: z.coerce.number(),
  layout_days_per_year: z.coerce.number().int(),
  layout_equipment_efficiency: z.coerce.number(),
  cost_per_head_per_hour: z.coerce.number(),
  labor_rate_per_hour: z.coerce.number(),
  overhead_percent: z.coerce.number(),
  labor_utilization: z.coerce.number(),
  ot_1_shift_percent: z.coerce.number(),
  ot_2_shifts_percent: z.coerce.number(),
  hours_day_1_shift: z.coerce.number(),
  hours_day_2_shifts: z.coerce.number(),
  hours_day_3_shifts: z.coerce.number(),
  hours_available_for_ac: z.coerce.number(),
  hours_day_1_shift_plus_ot: z.coerce.number(),
  hours_day_2_shift_plus_ot: z.coerce.number(),
  hours_day_3_shifts_plus_ot: z.coerce.number(),
  usable_hours_1_shift: z.coerce.number(),
  usable_hours_2_shifts: z.coerce.number(),
  usable_hours_3_shifts: z.coerce.number(),
});

export type TradeStudyInputs = z.infer<typeof TradeStudyInputs>;

export const TradeStudyInputsUpdate = TradeStudyInputs.omit({
  id: true,
  quote_id: true,
  /** Derived server-side from layout_days_per_year */
  m_days_per_month: true,
  /** Derived server-side from labor_rate_per_hour and overhead_percent */
  cost_per_head_per_hour: true,
  /** Derived server-side from layout_hours_per_shift */
  hours_day_1_shift: true,
  hours_day_2_shifts: true,
  hours_day_3_shifts: true,
  hours_day_1_shift_plus_ot: true,
  hours_day_2_shift_plus_ot: true,
  hours_day_3_shifts_plus_ot: true,
  usable_hours_1_shift: true,
  usable_hours_2_shifts: true,
  usable_hours_3_shifts: true,
});

export type TradeStudyInputsUpdate = z.infer<typeof TradeStudyInputsUpdate>;
